export default "__VITE_ASSET__DbCh0eFL__"